"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActionType = (function () {
    function ActionType() {
    }
    Object.defineProperty(ActionType, "NextMonth", {
        get: function () {
            return "NextMonth";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "PreviousMonth", {
        get: function () {
            return "PreviousMonth";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "AddDays", {
        get: function () {
            return "AddDays";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "SetMonth", {
        get: function () {
            return "SetMonth";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "GoToMonth", {
        get: function () {
            return "GoToMonth";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "SetDates", {
        get: function () {
            return "SetDates";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "UpdateEventFilter", {
        get: function () {
            return "UpdateEventFilter";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "UpdateEvents", {
        get: function () {
            return "UpdateEvents";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "ChangeProductionSeasonFilter", {
        get: function () {
            return "ChangeProductionSeasonFilter";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "BrowserNavigated", {
        get: function () {
            return "BrowserNavigated";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActionType, "EventUpdated", {
        get: function () {
            return "EventUpdated";
        },
        enumerable: true,
        configurable: true
    });
    return ActionType;
}());
exports.ActionType = ActionType;
//# sourceMappingURL=action-struct.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@adage/ace-calendar/app/actions/action-struct.js
// module id = 9
// module chunks = 0